<template>
    <OtherPerDiem></OtherPerDiem>
</template>
<script>
    import OtherPerDiem from '@/components/EmployeeOtherPerDiem.vue'
    export default {
        name: 'funding-management',
        components: {
            OtherPerDiem
        }
    }
</script>